import React, { Fragment, useState } from "react";
import { BiEnvelope } from "react-icons/bi";
import ArticleJoinForm from './ArticleJoinForm';
import ArticleLoginForm from './ArticleLoginForm';

const NotAMember = (props) => {
    const [isLoginTag, setLoginTag] = useState(true);
    const [isJoinTag, setJoinTag] = useState(false);

    return (
        <div>
            <Fragment>
            {isLoginTag ? (
                <div>
                    <p className="font-weight-bold" onClick={() => setLoginTag(false)}>Already a VIP Member</p>
                    <p className="text-blue" style={{textDecoration:'none',cursor: 'pointer'}}  onClick={() => setLoginTag(false)}>Login Here</p>
                    <a className="text-blue" onClick={() => setJoinTag(false)}> Not a Member yet?</a>
                    <p>Join my community. It's FREE!</p>
                    <p>After you join you can get unlimited free access to my
                    personal library of practical wellness resources and discover
                    how to have long-lasting vitality and well-being with shaklee
                    products.</p>
                    <div className="btn-join-email bg-success py-2 px-3 my-5 text-center" onClick={() => setJoinTag(false)}>
                        <h3 className="text-white"> 
                            <span className="float-left border-right pr-3"><BiEnvelope className="icon-message h1"/></span>
                            <span>Join Using Email</span>
                        </h3>
                    </div>
                    <Fragment>
                    {isJoinTag ? (
                        <div>
                            <p className="text-blue" onClick={() => setJoinTag(false)}>Join Here</p>
                        </div>
                    ) : (
                        <ArticleJoinForm props={props} />
                    )}
                    
                    </Fragment>
                </div>
            ) : (
                <ArticleLoginForm props={props}/>
            )}
            </Fragment>
            
        <style jsx global>{`
            .btn-join-email{
                background-color: #43a649!important;
                width:100%;
                max-width:450px;
            }

            .btn-join-email:hover,
            .btn-join-email:active,
            .btn-join-email:focus{
                text-decoration: none;
                background-color:#5ebe64!important;
                border:none!important;
            }
            .btn-join-email h3{
                text-align:center;
            }
        `}</style>

        </div>
    );
};

export default NotAMember;